export function getDistinctSdgs(projects?: Project[]): SustainableDevelopmentGoal[] {
  if (!projects || !projects.length) {
    return [];
  }
  const sdgMap = new Map<string, SustainableDevelopmentGoal>();

  projects.forEach(project => {
    project.sdgs?.forEach(sdg => {
      if (!sdg) {
        return;
      }
      sdgMap.set(sdg.id, sdg);
    });
  });

  return Array.from(sdgMap.values());
}

export function getCountryWithCity(project?: Partial<Project>): string {
  if (project?.country && project?.city) {
    return `${project?.country}, ${project.city}`;
  }
  if (project?.country) {
    return project?.country;
  }
  if (project?.city) {
    return project?.city;
  }
  return '';
}

export function getPortfolioCo2InTons(portfolioList: AttributionStatisticsPerPortfolio[], id: string): number {
  const portfolioCo2 = portfolioList?.find(portfolio => portfolio.group === id)?.kilosCo2 ?? 0;

  const portfolioCo2InTons = Math.round(portfolioCo2 / 1000);

  return portfolioCo2InTons;
}

export const toTons = (kilos: number): number => Math.round(kilos / 1000);
export const toTonsFixed = (kilos: number, decimal = 2): number => Number((kilos / 1000).toFixed(decimal));

export const removeNumberFromSDGTitle = (sdgTitle: string): string => {
  const splitText = sdgTitle.split('.');
  if (splitText.length > 1) {
    return splitText[1];
  }
  return sdgTitle;
};
